export const usersHeaders = [
  {name: 'User', val: 0},
  {name: 'Name', val: 1},
  {name: 'Email', val: 2},
  {name: 'Phone', val: 3},
  {name: 'City', val: 4},
  {name: 'Country', val: 5},
  {name: 'Actions', val: -1}
]